/* eslint-disable max-classes-per-file */
import _ from 'lodash';
import EventEmitter from 'events';
import InMemoryXRayGeneratorController from 'app/adapters/XRayGenerator/InMemoryXRayGeneratorController';
import {
  EVENT_GENERATOR_SWITCH,
  EVENT_GENERATOR_THICKNESS,
  EVENT_GENERATOR_WARNING,
  EVENT_SW_VER,
  OPERATING_MODE,
} from 'app/xray/generator/constants';

class TelemetryXRayGeneratorController extends InMemoryXRayGeneratorController {
  constructor(xrayGeneratorController) {
    super({ close: () => {} });
    this.xrayGeneratorController = xrayGeneratorController;

    this.xrayGeneratorController.on(EVENT_GENERATOR_THICKNESS, (event) => {
      this.dispatchEvent(
        _.merge(new Event(event.type, { thickness: event.thickness }), {
          thickness: event.thickness,
        })
      );
    });
    this.xrayGeneratorController.on(EVENT_GENERATOR_WARNING, () => {
      this.xrayGeneratorController.resetWarning();
    });

    this.xrayGeneratorController.on(EVENT_SW_VER, (event) => {
      this.dispatchEvent(
        _.merge(new Event(event.type), {
          version: event.version,
          major: event.major,
          minor: event.minor,
        })
      );
    });

    this.xrayGeneratorController.on(EVENT_GENERATOR_SWITCH, (event) => {
      this.dispatchEvent(
        _.merge(new Event(event.type, { status: event.status }), { status: event.status })
      );
    });

    this.requestPedaleStateDetection =
      this.xrayGeneratorController.requestPedaleStateDetection?.bind(this.xrayGeneratorController);
  }

  async init(date) {
    this.xrayGeneratorController.init(date);
  }

  async requestStatus() {
    await this.xrayGeneratorController.requestStatus();

    return super.requestStatus();
  }

  async changeOperatingMode(mode) {
    super.changeOperatingMode(mode);
    if (mode === OPERATING_MODE.STANDBY || mode === OPERATING_MODE.SLEEPING) {
      this.xrayGeneratorController.changeOperatingMode(mode);
    }
  }

  async requestThickness() {
    this.xrayGeneratorController.requestThickness();
  }

  shutdown() {
    this.xrayGeneratorController.shutdown();
  }
}

export default class TelemetryXRayGeneratorControllerHandle extends EventEmitter {
  constructor(xrayGeneratorHandle, generatorConnectionCallback = undefined) {
    super();

    this.id = xrayGeneratorHandle.id;
    this.xrayGeneratorHandle = xrayGeneratorHandle;
    this.generatorConnectionCallback = generatorConnectionCallback;
  }

  async connect(isDirectCommunicationMode = false) {
    this.xrayGeneratorHandle.on('disconnected', () => this.emit('disconnected'));

    const xrayGeneratorController = await this.xrayGeneratorHandle.connect(
      isDirectCommunicationMode
    );

    const dummyXRayGeneratorController = new TelemetryXRayGeneratorController(
      xrayGeneratorController
    );
    this.generatorConnectionCallback?.(dummyXRayGeneratorController);

    return dummyXRayGeneratorController;
  }
}
